import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { informationInterest } from './constants';
import './styles.css';
import { useNavigate } from 'react-router-dom';

const InformationInterestView = ({ eventData, origin }) => {
  const recoveryInfo = informationInterest[origin];
  const navigate = useNavigate();

  if (recoveryInfo === undefined) {
    navigate('/');
    return;
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [origin]);

  const { title, description, icon } = informationInterest[origin];
  return (
    <div
      className="containerResultInfo"
      style={{
        minHeight: eventData.height * 0.65,
        minWidth: eventData.width * 0.7,
      }}
    >
      <div className="containerTitle">
        <i className={`${icon}`} />
        <div className="title">{title}</div>
      </div>
      <div
        style={{ maxWidth: eventData.width * 0.8 }}
        className="description markdown-content prose"
      >
        <ReactMarkdown>{description}</ReactMarkdown>
      </div>
    </div>
  );
};

export default InformationInterestView;
